import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import { compose, space, layout, typography, color, flexbox, border, position, shadow, background } from 'styled-system';
import { getStyledFunctionsNames, shouldForwardProp as _shouldForwardProp, values } from './utils';
var VARIANTS = {
  UBER: 'uber',
  HERO: 'hero',
  LEAD: 'lead',
  BODY: 'body',
  CAPTION: 'caption',
  SMALL: 'small',
  TINY: 'tiny',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5'
};

var getVariant = function getVariant(variant) {
  return {
    fontSize: variant,
    lineHeight: variant,
    letterSpacing: variant === VARIANTS.CAPTION ? variant : null
  };
};

var styledFunctions = {
  color: color,
  typography: typography,
  space: space,
  layout: layout,
  flexbox: flexbox,
  border: border,
  position: position,
  shadow: shadow,
  background: background
};

var TextPrimitive =
/*#__PURE__*/
_styled('p', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return _shouldForwardProp(prop, styledFunctions);
  },
  target: "e831c830"
})("margin:0;white-space:normal;", compose.apply(void 0, _toConsumableArray(values(styledFunctions))), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var Text = function Text(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["variant"]);

  return React.createElement(TextPrimitive, _extends({}, getVariant(variant), props));
};

Text.defaultProps = {
  fontFamily: 'default',
  fontWeight: 'normal',
  color: 'inherit',
  variant: 'body'
};
Text.styledFunctions = getStyledFunctionsNames(styledFunctions);
export default Text;